import { localData } from "../api/localData";
import React from "react";
import { Box, Button, Container, Stack, Typography } from "@mui/material";
import { StorefrontRounded, ArrowOutward } from "@mui/icons-material";
import HomeSlider from "../components/root/HomeSlider";
import HomeSolution from "../components/root/HomeSolution";
import Partenaires from "../components/root/Partenaires";
import Produits from "../components/root/Produits";
import Services from "../components/root/Services";
import Contact from "../components/root/Contact";
import Confiance from "../components/root/Confiance";

function SectionDivider({ reverse = false }) {
  return (
    <Box
      sx={{
        position: "relative",
        height: { xs: 18, md: 22 },
        bgcolor: "#fff",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          left: "50%",
          top: "50%",
          transform: "translate(-50%, -50%)",
          width: "min(1120px, calc(100% - 32px))",
          height: 1,
          background: reverse
            ? "linear-gradient(90deg, rgba(18,52,101,0) 0%, rgba(18,52,101,0.16) 22%, rgba(249,168,54,0.48) 50%, rgba(18,52,101,0.16) 78%, rgba(18,52,101,0) 100%)"
            : "linear-gradient(90deg, rgba(18,52,101,0) 0%, rgba(249,168,54,0.42) 24%, rgba(18,52,101,0.18) 50%, rgba(249,168,54,0.42) 76%, rgba(18,52,101,0) 100%)",
        }}
      />
      <Box
        sx={{
          position: "absolute",
          left: "50%",
          top: "50%",
          transform: "translate(-50%, -50%)",
          width: 8,
          height: 8,
          borderRadius: "50%",
          bgcolor: "#f9a836",
          boxShadow: "0 0 0 5px rgba(249,168,54,0.12)",
        }}
      />
    </Box>
  );
}

export default function Home() {
  const societe = localData.societe;

  return (
    <>
      <HomeSlider />
      <Box component="section" aria-labelledby="store-heading" sx={{ py: { xs: 4, md: 5 }, bgcolor: "#f5faff" }}>
        <Container maxWidth="lg">
          <Stack direction={{ xs: "column", md: "row" }} spacing={3} alignItems={{ xs: "flex-start", md: "center" }} justifyContent="space-between">
            <Stack direction="row" spacing={2} alignItems="flex-start">
              <StorefrontRounded sx={{ color: "#123465", fontSize: 36 }} aria-hidden="true" />
              <Box>
                <Typography id="store-heading" component="h2" variant="h5" sx={{ color: "#123465", fontWeight: 800, mb: 1 }}>Notre boutique en ligne</Typography>
                <Typography sx={{ color: "#374151", lineHeight: 1.7 }}>Découvrez notre sélection d’équipements professionnels et préparez votre commande ou votre demande de devis.</Typography>
              </Box>
            </Stack>
            <Button component="a" href="https://store.teledyne.ma/" target="_blank" rel="noopener noreferrer"
              aria-label="Accéder à la boutique (nouvel onglet)" variant="contained" endIcon={<ArrowOutward />}
              sx={{ bgcolor: "#123465", borderRadius: "12px", px: 3, py: 1.4, textTransform: "none", fontWeight: 700, flexShrink: 0, '&:hover': { bgcolor: "#f9a836", color: "#123465" } }}>
              Accéder à la boutique
            </Button>
          </Stack>
        </Container>
      </Box>
      <HomeSolution />
      <SectionDivider reverse />
      <Produits />
      <SectionDivider />
      <Services />
      <Contact />
      <Partenaires partenaire={societe} />
      <Confiance confiance={societe} />
    </>
  );
}
